import { createElement } from 'react';
import { a2 as LinkImage$1, _ as __assign } from '../../index.esm-5f955dcb.js';
import 'react-measure';
import 'react-router-dom';
import 'react-dom';
import 'throttle-debounce';
import 'focus-trap-react';
import 'react-swipeable';
import 'react-animate-height';
import 'country-flag-emoji-polyfill';
import 'intersection-observer';
import 'html-react-parser';

var LinkImage = function LinkImage(props) {
  return /*#__PURE__*/createElement(LinkImage$1, __assign({}, props));
};
LinkImage.displayName = 'LinkImage';

export { LinkImage };
